import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX } from '../utils/constants';

export const addToGoogleCalendar = async (
  appointment_id: number
): Promise<any> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}calendar/google/${appointment_id}`
    );

    return data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error(error);
  }
};
